import { render, staticRenderFns } from "./optionQuota.vue?vue&type=template&id=a957a35a&scoped=true&"
import script from "./optionQuota.vue?vue&type=script&lang=js&"
export * from "./optionQuota.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a957a35a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/3ztxUiUz/0/ifirst/dt-survey/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a957a35a')) {
      api.createRecord('a957a35a', component.options)
    } else {
      api.reload('a957a35a', component.options)
    }
    module.hot.accept("./optionQuota.vue?vue&type=template&id=a957a35a&scoped=true&", function () {
      api.rerender('a957a35a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormGen/FormDesign/ItemConfig/optionQuota.vue"
export default component.exports